import { Link } from 'react-router-dom'
import { ProgressBarWheelIcon } from '../ProgressBarWheelIcon/ProgressBarWheelIcon'
import { RoutePaths } from 'src/routes/routePaths'

interface OnboardingHubProgressLinkProps {
  dark?: boolean
  className?: string
  'data-testid'?: string
}

export function OnboardingHubProgressLink({
  dark = false,
  className = '',
  'data-testid': dataTestId = 'onboarding-link'
}: Readonly<OnboardingHubProgressLinkProps>) {
  // TODO: Replace with actual progress calculation from your application state
  const progress = 30

  return (
    <Link
      to={RoutePaths.ONBOARDING_HUB}
      data-testid={dataTestId}
      className={className}>
      <ProgressBarWheelIcon progress={progress} dark={dark} />
      <span>Your Journey</span>
    </Link>
  )
}
